import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title as ChartTitle,
  Tooltip as ChartTooltip,
  Legend
} from 'chart.js';
import {
  Container,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import Navbar from "../../../../globals/components/Navbar";
import "react-toastify/dist/ReactToastify.css";

import useCarrierProfile from "./hooks/useCarrierProfile";
import CarrierProfileHeaderCards from "./components/CarrierProfileHeaderCards";
import CarrierProfileTabsCard from "./components/CarrierProfileTabsCard";
import CarrierProfileDialogs from "./components/CarrierProfileDialogs";

ChartJS.register(CategoryScale, LinearScale, BarElement, ChartTitle, ChartTooltip, Legend);

function CarrierProfile() {
  const vm = useCarrierProfile();

  return (
    <>
      <Navbar/>
      <Container maxWidth="xl" sx={{ marginTop: 4, marginBottom: 4 }}>
        <Grid container spacing={3}>
          <CarrierProfileHeaderCards vm={vm} />
          <CarrierProfileTabsCard vm={vm} />
        </Grid>
      </Container>
      <CarrierProfileDialogs vm={vm} />
    </>
  );
}

export default CarrierProfile;
